import { TRACKERS } from "@/constants/Trackers";
import { Profile } from "@/features/Patient/MedicalRecords/Profile/Profile";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/profile")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_PROFILE);
  },
});

function RouteComponent() {
  return <Profile />;
}
